var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#refresh_react_svg__clip0_28469_41696)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.757 3.757A6 6 0 0114 8h2A8 8 0 002.349 2.337l-.002.002-.023.023-.081.082c-.06.06-.143.146-.243.254V1H0v4a1 1 0 001 1h4V4H3.52a9.8 9.8 0 01.209-.214l.012-.013.002-.002.007-.006.007-.008zM8 14a6 6 0 01-6-6H0a8 8 0 0014 5.291V15h2v-4a1 1 0 00-1-1h-4v2h1.472A5.984 5.984 0 018 14z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "refresh_react_svg__clip0_28469_41696"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgRefreshreact;